<template>
  <div class="nav desktop-nav">
    <a :href="`${baseUrl}`" class="pixel-corners">Home</a>
    <a :href="`${baseUrl}about`" class="pixel-corners">About</a>
    <a :href="`${baseUrl}how-to-buy`" class="pixel-corners">How to buy</a>
    <a :href="`${baseUrl}faq`" class="pixel-corners">FAQ</a>
    <a :href="`${baseUrl}xbank`" class="pixel-corners">XBANK</a>
    <a :href="`${baseUrl}profile`" class="pixel-corners">Profile</a>
  </div>

  <div class="nav mobile-nav">
    <!-- Hamburger Button -->
    <button @click="toggleNav" 
      class="hamburger btn btn-light border-2 border-white top-5 float-left left-5 absolute"
      style="width: 48px;">
      ☰
    </button>

    <!-- Overlay -->
    <div
      v-if="isOpen"
      @click="toggleNav"
      class="fixed inset-0 bg-black bg-opacity-50 z-40"
    ></div>

    <!-- Sidebar Navigation -->
    <transition name="slide">
      <nav
        v-if="isOpen"
        class="fixed top-0 left-0 h-full w-64 shadow-lg p-5"
        style="background: #414066; z-index: 903;"
      >
        <button @click="toggleNav" class="text-white text-2xl absolute top-4 right-4">
          <img src="../assets/images/icon-close-white.png" alt="X" width="40" height="40" style="filter: brightness(3) saturate(100%);">
        </button>
        <ul class="mt-10 space-y-4">
          <li><a :href="baseUrl" class="float-right mt-2 mb-2 pixel-corners">Home</a></li>
          <li><a :href="`${baseUrl}about`" class="float-right mt-2 mb-2 pixel-corners">About</a></li>
          <li><a :href="`${baseUrl}how-to-buy`" class="float-right mt-2 mb-2 pixel-corners">How to buy</a></li>
          <li><a :href="`${baseUrl}faq`" class="float-right mt-2 mb-2 pixel-corners">FAQ</a></li>
          <li><a :href="`${baseUrl}xbank`" class="float-right mt-2 mb-2 pixel-corners">XBANK</a></li>
          <li><a :href="`${baseUrl}profile`" class="float-right mt-2 mb-2 pixel-corners">Profile</a></li>
        </ul>
      </nav>
    </transition>
  </div>
</template>

<script setup>
import { ref, defineProps } from "vue";

const isOpen = ref(false);
const baseUrl = ref(process.env.VUE_APP_PUBLIC_PATH);

const toggleNav = () => {
  isOpen.value = !isOpen.value;
};

// Define props (since you're using <script setup>)
defineProps({
  customerAcc: String
});
</script>

<style>
.slide-enter-active, .slide-leave-active {
  transition: transform 0.3s ease-in-out;
}
.slide-enter-from, .slide-leave-to {
  transform: translateX(-100%);
}

.nav {
  display: flex;
  justify-content: center;
  margin: auto;
  margin-top: 1rem;
  margin-bottom: 1rem;
  color: inherit;
}

.nav a {
  margin: 0.3rem 1rem;
  padding: 0.5rem 1rem;
  color: #3185fc;
  text-decoration: none;
  background-color: white;
  align-content: center;
  font-size: 1.1rem;
  font-weight: bold;
}

.desktop-nav {
  display: flex;
}

.mobile-nav {
  display: none;
}

.mobile-nav nav ul li a {
  width: 90%;
  margin-top: 1rem;
}

/* Switch to mobile nav when screen width is 800px or less */
@media (max-width: 800px) {
  .desktop-nav {
    display: none;
  }

  .mobile-nav {
    display: block;
  }
}
</style>
